// extracted by mini-css-extract-plugin
export default {"pageContainer__container":"PageContainer_pageContainer__container__3x+CS"};